<template>
    <button class="button is-primary" :class="{ 'is-loading': loading }" @click="$emit('click')">
    <span class="icon">
      <i class="fa fa-check"></i>
    </span>
    <span v-if="label">{{label}}</span>
  </button>
</template>

<script>
export default {
  name: 'PublishButton',
  props: {
    label: String,
    loading: Boolean
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/forms/PublishButton.vue